// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import useMergeProps from '../../../hooks/useMergeProps';
import { KLCollarCounterIcon } from '../assets/img';
import KLCounter from '../components/common/KLCounter';
import selectKLCollarProps from '../selectors/specifics/selectKLCollarProps';

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: -35%;
  height: 175%;
  transform: translateY(-50%);
  filter: drop-shadow(0px 1px 2px black);
`;

const StyledIcon = styled.img`
  height: 100%;
  transition: filter 300ms ease-in-out;

  ${({ $nbCollars }) => {
    if (!$nbCollars) {
      return css`
        filter: brightness(70%);
      `;
    }
  }}
`;

type KLCollarCounterContainerProps = {
  className?: string;
  roundIndex: number;
};

const KLCollarCounterContainer = ({ roundIndex, ...ownProps }: KLCollarCounterContainerProps) => {
  const selectorProps = useMemo(() => ({ roundIndex }), [roundIndex]);
  const selectedProps = useSelector((state) => selectKLCollarProps(state, selectorProps));

  const Icon = useMemo(
    // eslint-disable-next-line react/display-name
    () => () => (
      <IconWrapper>
        <StyledIcon src={KLCollarCounterIcon} alt="Number of collars" $nbCollars={selectedProps.counter} />
      </IconWrapper>
    ),
    [selectedProps.counter],
  );

  const otherProps = useMemo(() => ({ Icon }), [Icon]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <KLCounter {...enhancedProps} />;
};

export default KLCollarCounterContainer;
